import type { ModuleFolderStructureItem, ModuleFolderStructureOutput, TemplateInfo } from "@scayla/api-client-fetch";
import { SidebarStatus } from "@scayla/api-client-fetch/types";

const NON_CREATABLE_STATUSES = new Set<SidebarStatus>([SidebarStatus.LOCKED, SidebarStatus.DRAFT]);

/** Every template of a module's folder structure: the root templates first, then each folder depth-first. */
export function collectModuleTemplates(structure: ModuleFolderStructureOutput): TemplateInfo[] {
  return [...(structure.templates ?? []), ...(structure.folders ?? []).flatMap(collectFolderTemplates)];
}

function collectFolderTemplates(folder: ModuleFolderStructureItem): TemplateInfo[] {
  return [...(folder.templates ?? []), ...(folder.folders ?? []).flatMap(collectFolderTemplates)];
}

/** Whether the sidebar lists a template. A module's list still shows the records of the ones it hides. */
export function isNavigationTemplate(
  template: Pick<TemplateInfo, "showInNavigation">,
  permissions: { read: boolean },
): boolean {
  return permissions.read && template.showInNavigation;
}

/** Whether a template's status allows new records; locked and draft templates are hidden from the picker. */
export function isCreatableTemplateStatus(template: Pick<TemplateInfo, "status">): boolean {
  return !NON_CREATABLE_STATUSES.has(template.status);
}
